export default {
  reset(state) {
    state.page = 0;
    state.brushColor = '#ff0000';
    state.brushWidth = 5;
    state.showBackgroundImage = true;
    state.mode = 'pencil';
    state.scale = 1;
    state.maxScale = 2;
    state.minScale = 0.8;
    state.boards = [];
  },

  updateStates(state, payload) {
    for (let key in payload) {
      if (!payload.hasOwnProperty(key)) {
        continue;
      }
      if (state[key] === payload[key]) {
        return;
      }
      state[key] = payload[key];
    }
  },

  addBoard(state, board) {
    state.boards.push(board);
  },

  removeBoard(state, boardId) {
    let index = state.boards.findIndex(b => {
      return b.id === boardId;
    });
    if (index >= 0) {
      state.boards.splice(index, 1);
    }
  }
};
